import { all, spawn, call } from 'redux-saga/effects';
import authSaga from './authSaga';
import balanceSaga from './balanceSaga';
import userServletSaga from './userServletSaga';
import contactServletSaga from './contactServletSaga';
import repliesServletSaga from './repliesServletSaga';
import servletSaga from './servletSaga';
import othersSaga from './othersSaga';
import manageUserSaga from './manageUserSaga';
import dialogsSaga from './dialogsSaga';
import statsSaga from './statsSaga';
import didsSaga from './didsSaga';
import paymentSaga from './paymentSaga';
import domainSaga from './domainSaga';
import creativeSaga from './creativeSaga';
import offerSaga from './offerSaga';
import notificationSaga from './notificationSaga';
import guidelineSaga from './guidelineSaga';
import premiumSaga from './premiumSaga';
import { watchCreatorSaga } from '../creator/creatorModules';

export default function* rootSaga() {
  const sagas = [
    authSaga,
    notificationSaga,
    offerSaga,
    creativeSaga,
    balanceSaga,
    userServletSaga,
    contactServletSaga,
    repliesServletSaga,
    servletSaga,
    othersSaga,
    manageUserSaga,
    dialogsSaga,
    statsSaga,
    didsSaga,
    paymentSaga,
    domainSaga,
    guidelineSaga,
    premiumSaga,
    watchCreatorSaga,
  ];

  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log(e);
          }
        }
      })
    )
  );
}
